import React, {useEffect, useState} from 'react';
import {Grid, IconButton, Typography, Tooltip} from "@mui/material";
import {ERROR_COLOR, GRAY, INFO_COLOR, SECONDARY_COLOR, SUCCESS_COLOR, TERTIARY_COLOR} from "../../../constants/Colors";
import {makeStyles} from "@mui/styles";
import {pento4BedImage, pento5BedImage, E5A5B4A4B, skyExchangeImage} from "./ChartData";
import EditIcon from '@mui/icons-material/Edit';
import AddPrice from "./AddPrice";
import AddAvailability from "./AddAvailability";
import {AuthenticationContext} from "../../../contexts/AuthContext";
import {addThousandSeparator} from "../../../utilities/Others";
import {ChartContext} from "../../../contexts/ChartContext";
import VillageTotalAreaAndPrice from "./VillageTotalAreaAndPrice";

const useStyles = makeStyles((theme) => ({
    boxContainer: {
        backgroundColor: SECONDARY_COLOR,
        padding: 6,
        height: 60,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    itemContainer: {
        backgroundColor: GRAY,
        width: '100%',
        padding: 3,
        //marginTop: 3,
        height: '100%'
    }
}));

const styles = {
    title: {
        fontWeight: 200,
        fontFamily: 'MontserratLight !important',
        textAlign: 'center'
    },
}

const numberToWords = (num) => {
    num = Math.floor(Number(num));

    if (!num || isNaN(num)) return '';

    const ones = [
        '', 'One', 'Two', 'Three', 'Four', 'Five',
        'Six', 'Seven', 'Eight', 'Nine', 'Ten',
        'Eleven', 'Twelve', 'Thirteen', 'Fourteen',
        'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen',
        'Nineteen'
    ];

    const tens = [
        '', '', 'Twenty', 'Thirty', 'Forty',
        'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
    ];

    const belowThousand = (n) => {
        let result = '';

        if (n >= 100) {
            result += ones[Math.floor(n / 100)] + ' Hundred ';
            n %= 100;
        }

        if (n >= 20) {
            result += tens[Math.floor(n / 10)] + ' ';
            n %= 10;
        }

        if (n > 0) {
            result += ones[n] + ' ';
        }

        return result.trim();
    };

    const convert = (n) => {
        if (n < 1000) return belowThousand(n);

        if (n < 100000) {
            return belowThousand(Math.floor(n / 1000)) +
                ' Thousand ' + convert(n % 1000);
        }

        if (n < 10000000) {
            return convert(Math.floor(n / 100000)) +
                ' Lakh ' + convert(n % 100000);
        }

        return convert(Math.floor(n / 10000000)) +
            ' Crore ' + convert(n % 10000000);
    };

    return convert(num).replace(/\s+/g, ' ').trim();
};

export default function ChartListData({item, selected, setTitle, setImage, nexusSelected, pentoSelected, USDRate}) {

    const classes = useStyles();
    const [onHoverUnit, setOnHoverUnit] = useState('');
    const [onHoverPrice, setOnHoverPrice] = useState('');
    const [openPrice, setOpenPrice] = useState(false),
        [currentPrice, setCurrentPrice] = useState('');
    const [openAvailability, setOpenAvailability] = useState(false),
        [currentStatus, setCurrentStatus] = useState('');

    const authenticationContext = React.useContext(AuthenticationContext);
    const {userAccount} = authenticationContext;

    const handelClickUnits = (data) => {
        if(selected === 'PENTO') {
            if(pentoSelected === '4 Bed') {
                const title =  `4 Bedrooms - ${data.floorName} Floor`
                setTitle(title)
                setImage(pento4BedImage)
            } else if(pentoSelected === '5 Bed') {
                const title =  `5 Bedrooms - ${data.floorName} Floor`
                setTitle(title)
                setImage(pento5BedImage)
            }else {
                setTitle('Floor Plan');
            }
        } else if(selected === 'NEXUS') {
            if(nexusSelected === '3 Bed') {
                const title =  `3 Bedrooms - ${data.floorName} Floor`
                setTitle(title)
            } else if(nexusSelected === '4 Bed') {
                const title =  `4 Bedrooms - ${data.floorName} Floor`
                setTitle(title)
            }
        } else if(selected === 'SKYEXCHANGE') {
            const title =  `${data.unit} Office - ${data.floorName} Floor`
            setTitle(title)
            if(data.floorName === '7th' || data.floorName === '8th'){
                setImage(E5A5B4A4B);
            }else if(data.floorName === '3rd' || data.floorName === '4th' || data.floorName === '5th' || data.floorName === '6th'){
                setImage('https://api.rivieragroup.pk/media/skygarden-images/images/Office/Office-1-4x4.png');
            } else{
                setImage(skyExchangeImage);
            }
        } else if(selected === 'VILLAGE') {
            const title =  `${data.unit} Office - ${data.floorName} Floor`
            setTitle(title)
            if(data.floorName === 'Ground'){
                setImage('https://api.rivieragroup.pk/media/skygarden-images/images/SkyVillage/plans/v2/ground.png');
            }else if(data.floorName === 'First'){
                setImage('https://api.rivieragroup.pk/media/skygarden-images/images/SkyVillage/plans/v2/first.png');
            } else if(data.floorName === 'Second'){
                setImage('https://api.rivieragroup.pk/media/skygarden-images/images/SkyVillage/plans/v2/second.png');
            }
        }
    }

    const getMarginButton = () => {
        return (selected === 'PENTO' && pentoSelected === 'Duplex') || (selected === 'PENTO' && pentoSelected === 'Penthouse') ? 0 : 0.5;
    }

    return (
        <Grid container>
            <Grid item xs={1.5}
                  pr={{xs: 0.5, sm: 0.5, md: 0.5}}
                  mb={0.5}
            >
                <div className={classes.itemContainer}>
                    <Typography variant='body2'
                                sx={[styles.title, {color: SECONDARY_COLOR}]}
                    >
                        {item.floorName}
                    </Typography>
                </div>
            </Grid>
            <Grid item xs={1.5} mb={getMarginButton()}
                  pr={{xs: 0.5, sm: 0.5, md: 0.5}}
                  sx={{
                      cursor: 'pointer', userSelect: 'none'
                  }}
                  onClick={() => {handelClickUnits(item)}}
            >
                <div className={classes.itemContainer}
                     style={{
                         backgroundColor: item.unitStatus === 'SOLD' ? ERROR_COLOR :
                             item.unitStatus === 'RESERVED' ? INFO_COLOR :
                                 item.unitStatus === 'AVAILABLE' ? SUCCESS_COLOR : TERTIARY_COLOR,
                         position: 'relative'
                     }}
                     onMouseOver={() => setOnHoverUnit(item.floorName)}
                     onMouseLeave={() => setOnHoverUnit('')}
                >
                    <Typography variant='body2'
                                sx={[styles.title, {color: SECONDARY_COLOR}]}
                    >
                        {item.unit}
                    </Typography>
                    {
                        !(userAccount?.permissions?.includes('EDIT_FLOOR_STATUS')) ? null :
                        onHoverUnit === item.floorName ?
                            <Tooltip title={"Edit Availability"}>
                                <IconButton
                                    onClick={() => {
                                        setCurrentStatus(item.unitStatus)
                                        setOpenAvailability(true)
                                    }}
                                    sx={{zIndex: 1000,
                                        position: 'absolute',
                                        top: 0, right: 0
                                    }}
                                >
                                    <EditIcon style={{fontSize: 16}}/>
                                </IconButton>
                            </Tooltip>
                            : null
                    }
                </div>
            </Grid>
            {
                !(selected === 'PENTO') ? null :
                    <Grid item xs={1.5} mb={getMarginButton()}
                          pr={{xs: 0.5, sm: 0.5, md: 0.5}}
                    >
                        <div className={classes.itemContainer}>
                            <Typography variant='body2'
                                        sx={[styles.title, {color: SECONDARY_COLOR}]}
                            >
                                {item.rooms}
                            </Typography>
                        </div>
                    </Grid>
            }
            <Grid item xs={2} mb={getMarginButton()}
                  pr={{xs: 0.5, sm: 0.5, md: 0.5}}
            >
                <div className={classes.itemContainer}>
                    <Typography variant='body2'
                                sx={[styles.title, {color: SECONDARY_COLOR}]}
                    >
                        {item.grossArea ? addThousandSeparator(item.grossArea.toString()) : null}
                    </Typography>
                </div>
            </Grid>
            {/*<Grid item xs={1} sm={1} md={1} mb={getMarginButton()}*/}
            {/*      pr={{xs: 0.5, sm: 0.5, md: 0.5}}*/}
            {/*>*/}
            {/*    <div className={classes.itemContainer}>*/}
            {/*        <Typography variant='body2'*/}
            {/*                    sx={[styles.title, {color: SECONDARY_COLOR}]}*/}
            {/*        >*/}
            {/*            {item.netArea ? addThousandSeparator(item.netArea.toString()) : null}*/}
            {/*        </Typography>*/}
            {/*    </div>*/}
            {/*</Grid>*/}
            <Grid item xs={2.5} mb={getMarginButton()} pr={{xs: 0.5, sm: 0.5, md: 0.5}}>
                <div className={classes.itemContainer}
                     style={{position: 'relative'}}
                >
                    <Typography variant='body2'
                                sx={[styles.title, {color: SECONDARY_COLOR, fontSize: 12, textAlign: 'left'}]}
                    >
                        {
                            item.price && item.grossArea ?
                                numberToWords(parseFloat(item.price / item.grossArea).toFixed(0))
                                : null
                        }
                    </Typography>
                </div>
            </Grid>
            <Grid item xs={3} mb={getMarginButton()} pr={{xs: 0.5, sm: 0.5, md: 0.5}}>
                <div className={classes.itemContainer}
                     style={{position: 'relative'}}
                     onMouseOver={() => setOnHoverPrice(item.floorName)}
                     onMouseLeave={() => setOnHoverPrice('')}
                >
                    <Typography variant='body2'
                                sx={[styles.title, {color: SECONDARY_COLOR, fontSize: 12, textAlign: 'left'}]}
                    >
                        {item.price ? numberToWords(item.price) : null}
                    </Typography>
                    {
                        !(userAccount?.permissions?.includes('EDIT_FLOOR_PRICE')) ? null :
                            item.grossArea && onHoverPrice === item.floorName ?
                            <Tooltip title={"Edit Price"}>
                                <IconButton
                                    onClick={() => {
                                        setOnHoverPrice(item.price)
                                        setOpenPrice(true);
                                    }}
                                    sx={{zIndex: 1000,
                                        position: 'absolute',
                                        top: 0, right: 0
                                    }}
                                >
                                    <EditIcon style={{fontSize: 16}}/>
                                </IconButton>
                            </Tooltip>
                            : null
                    }
                </div>
            </Grid>
            {
                selected === 'VILLAGE' && <VillageTotalAreaAndPrice item={item} classes={classes} styles={styles}/>
            }
            <AddPrice
                open={openPrice}
                handleClose={() => setOpenPrice(false)}
                value={item} selected={selected}
                currentPrice={currentPrice}
                setCurrentPrice={setCurrentPrice}
                nexusSelected={nexusSelected}
            />
            <AddAvailability
                open={openAvailability}
                handleClose={() => setOpenAvailability(false)}
                status={currentStatus}
                setStatus={setCurrentStatus}
                value={item} selected={selected}
                nexusSelected={nexusSelected}
            />
        </Grid>
    );
}
